import {
    Avatar,
    AvatarFallback,
    AvatarImage,
} from "../ui/avatar"
import { RecentTransaction } from "../../api/admin.api"

interface RecentSalesProps {
    data: RecentTransaction[]
}

export function RecentSales({ data }: RecentSalesProps) {
    if (!data || data.length === 0) {
        return (
            <div className="flex h-[200px] items-center justify-center rounded-md border border-dashed text-sm text-muted-foreground">
                Aucune transaction récente
            </div>
        )
    }

    return (
        <div className="space-y-8">
            {data.map((item) => (
                <div key={item.id} className="flex items-center">
                    <Avatar className="h-9 w-9">
                        <AvatarImage src={`https://api.dicebear.com/7.x/initials/svg?seed=${item.client_name}`} alt={item.client_name} />
                        <AvatarFallback>{item.client_initials}</AvatarFallback>
                    </Avatar>
                    <div className="ml-4 space-y-1">
                        <p className="text-sm font-medium leading-none">{item.client_name}</p>
                        <p className="text-sm text-muted-foreground">
                            {item.email || item.phone || item.type_display}
                        </p>
                    </div>
                    <div className="ml-auto font-medium">+{item.formatted_amount}</div>
                </div>
            ))}
        </div>
    )
}
